import { render } from "./DisplayedValue.vue?vue&type=template&id=8ff6fd9e"
import script from "./DisplayedValue.vue?vue&type=script&lang=js"
export * from "./DisplayedValue.vue?vue&type=script&lang=js"

import "./DisplayedValue.vue?vue&type=style&index=0&id=8ff6fd9e&lang=scss"
script.render = render

export default script